<template>
    <v-card  d-flex >
        <v-card-text>
        <v-layout>
            <v-flex class='white' sm12 md12 lg8 d-flex>
                <v-chart :options="graph(formattedData)" lg6>

                </v-chart>
            </v-flex>
            <!-- TODO: SIZE NEEDS TO BE AJUSTED FOR lg format --> 
            <v-flex d-flex sm12 md12 lg6>
                <v-layout  justify-space-between wrap >
                    <div class="dd-status-legend-item" style="border-left-color: #8BC34A">
                        <div class="dd-status-legend-title">Status Ok</div>
                        <div class="dd-status-legend-number">{{statusses.ok}}</div>
                    </div>
                    <div class="dd-status-legend-item" style="border-left-color: #FF9800">
                        <div class="dd-status-legend-title">Waarschuwing</div>
                        <div class="dd-status-legend-number">{{statusses.warning}}</div>
                    </div>
                    <div class="dd-status-legend-item" style="border-left-color: #F44336">
                        <div class="dd-status-legend-title">Foutmelding</div>
                        <div class="dd-status-legend-number">{{statusses.error}}</div>
                    </div>
                    <div class="dd-status-legend-item" style="border-left-color: #2196F3">
                        <div class="dd-status-legend-title">Actie gepland</div>
                        <div class="dd-status-legend-number">{{statusses.action}}</div>
                    </div>
                    <div class="dd-status-legend-item" style="border-left-color: #9C27B0">
                        <div class="dd-status-legend-title">Foutmelding met Actie</div>
                        <div class="dd-status-legend-number">{{statusses.error_with_action}}</div>
                    </div>
                </v-layout>
            </v-flex> 
        </v-layout>       
        </v-card-text>
    </v-card>
</template>
<script>
    import ECharts from 'vue-echarts'

    export default{
        components: {
            'v-chart': ECharts
        },
        computed:{
            formattedData(){
                let data = [
                    this.statusses.ok,                    
                    this.statusses.action,
                    this.statusses.warning,
                    this.statusses.error_with_action,
                    this.statusses.error
                ]
                return data;
                
            },
            colors(){
                return ['#8BC34A', '#2196F3', '#FF9800', '#9C27B0','#F44336']
            }
        },
        props: ['statusses'],
        methods:{
            graph(gData, dataTitle){

                let graph = {                    
                        title: {
                            show: false,                    
                        },
                        color: this.colors, //['#8BC34A', '#FF9800', '#F44336', '#2196F3', '#9C27B0'],
                        tooltip : {
                            trigger: 'item',
                            formatter: " {c} ({d}%)"
                        },
                        toolbox: {
                            show : false,
                            
                        },                
                        legend: {
                            show : false,  
                            data:['Ok', 'Waarschuwing', 'Fout', 'Actie', 'Fout met actie']                  
                        },
                        series : [
                            {
                                name:'',
                                type:'pie',
                                radius : [50, 110],
                                center : ['50%', '50%'],
                                //roseType: 'radius',
                                data:[...gData].sort(function (a, b) { return a.value - b.value; }),

                                label: {
                                    normal: {
                                        show: false
                                    },
                                    emphasis: {
                                        show: false
                                    }
                                },
                                lableLine: {
                                    normal: {
                                        show: false
                                    },
                                    emphasis: {
                                        show: false
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                },
                            }
                        ]
                    }
                    return graph
            }
        }
    }
</script>

<style >
.dd-status-legend-item{
    border-left: solid 12px;
    padding-left: 6px;
    width: 50%;
    margin-top: 16px;
}

.dd-status-legend-number{
    font-size: 1.2vw;
    font-weight: 800;
}

.dd-status-legend-title{
    font-size: 0.5vw;
    text-transform: uppercase;
}
</style>